"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlocklistService = void 0;
class BlocklistService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * list creators blocklist
     * @param filtersjson
     * @param page
     * @param count
     * @returns ListCreatorsBlocklistRes
     * @throws ApiError
     */
    listCreatorsBlocklist(filtersjson, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/blocklist/list',
            query: {
                'filtersjson': filtersjson,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Updates creator blocklist information by id.
     * @param creatorId creator uuid
     * @param requestBody
     * @returns SuccessIdResponse
     * @throws ApiError
     */
    updateBlockedCreator(creatorId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/blocklist/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove blocked creator from blocklist by creator id.
     * @param creatorId creator uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    removeBlockedCreator(creatorId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/blocklist/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Add a new blocked creator to blocklist
     * @param requestBody
     * @returns CreateCreatorBlocklistRes
     * @throws ApiError
     */
    addBlockedCreator(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/blocklist/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.BlocklistService = BlocklistService;
